// pages/automations/AutomationEditorPage.tsx
import {useNavigate, useParams} from "react-router-dom";
import AutomationEditor from "./AutomationEditor";
import useUserContext from "../../hooks/useUserContext";

export default function AutomationEditorPage({ mode }: { mode: "create" | "edit" }) {
    const navigate = useNavigate();
    const { automationId } = useParams();
    const { selectedDomain } = useUserContext();

    const id = mode === "edit" ? Number(automationId) : undefined;
    const validId = Number.isFinite(id as number) ? (id as number) : undefined;

    if(!selectedDomain || (mode === "edit" && !validId)) return null;

    return (
        <AutomationEditor
            domain={selectedDomain}
            automationId={mode === "edit" ? Number(automationId) : undefined}
            onSaved={(id) => {
                navigate(`/automations-pro/${id}`);
            }}
        />
    );
}
